/**
 * Web Style Import
 *
 */

import './style/dnb-list.scss'
